import {
  List,
  ListItem,
  HStack,
  VStack,
  Box,
  Text,
  Button,
  CircularProgress,
} from "@chakra-ui/react";

import { useMemo } from "react";
import { CgDatabase } from "react-icons/cg";

import { format, parseISO } from "date-fns";
import toLower from "lodash/toLower";
import formatter from "util/formatter";
import toPrecision from "util/toPrecision";

import constants from "config/constant";

export const TransactionItem = ({
  type,
  unit,
  description,
  createdAt,
  value,
  isLast,
  onClick,
  _item,
}) => {
  // const { isOpen, onClose /*onOpen*/ } = useDisclosure();

  const getColor = (type) => {
    const map = {
      credit: "#00BA88",
      debit: "#ED2E7E",
    };

    return map[toLower(type) ?? "credit"];
  };

  const getType = (type) => {
    const map = {
      [toLower(type)]: toLower(type).includes("debit") ? "debit" : "credit",
      contract_credit: "credit",
      contract_debit: "debit",
    };

    return map[toLower(type)];
  };

  const isFiat = useMemo(() => constants.fiats?.includes(unit), [unit]);

  return (
    <>
      <ListItem
        w="100%"
        // minW="100%"
        as={Button}
        minH="fit-content"
        bg="transparent"
        // bg="#FCFCFC"
        p="32px 0"
        borderRadius="2px"
        borderBottom={!isLast ? "1px solid #EAEAEA4f" : "none"}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onClick}
        {..._item}
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={getColor(getType(type))}
            />
            <Box maxW="180px">
              <Text
                textAlign="left"
                fontSize="14px"
                fontWeight="400"
                color="#4E4B66"
                w="100%"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                m="0 !important"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="12px" mt="2px" color="#A0A3BD">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text color="#4E4B66" fontSize="14px" fontWeight="600">
            {toLower(type) === "debit" ? "-" : ""}
            {isFiat && formatter(unit).format(value?.$numberDecimal)}
            {!isFiat && toPrecision(value?.$numberDecimal, unit)}
          </Text>
        </HStack>
      </ListItem>

      {/* <TransactionDetailModal
          type={type}
          description={description}
          amount={value?.$numberDecimal}
          createdAt={createdAt}
          unit={unit}
          title={`${description} Details`}
          onClose={onClose}
          isOpen={isOpen}
        /> */}
    </>
  );
};

const RecentTransaction = ({
  transactions,
  isLoading,
  hasBorderBottom,
  showTitle = true,
  _tx,
  ...xprops
}) => {
  // const history = useHistory();

  const items = [
    {
      type: "credit",
      description: "Fund Deposit",
      value: {
        $numberDecimal: 12235871.9,
      },
      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
    {
      type: "debit",
      description: "Fund withdrawal",
      value: {
        $numberDecimal: 12235871.9,
      },

      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
    {
      type: "credit",
      description: "Fund Deposit",
      value: {
        $numberDecimal: 12235871.9,
      },
      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
    {
      type: "credit",
      description: "Fund Deposit",
      value: {
        $numberDecimal: 12235871.9,
      },
      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
    {
      type: "credit",
      description: "Fund Deposit",
      value: {
        $numberDecimal: 12235871.9,
      },
      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
    {
      type: "credit",
      description: "Fund Deposit",
      value: {
        $numberDecimal: 12235871.9,
      },
      unit: "ngn",
      createdAt: new Date().toISOString(),
    },
  ];

  return (
    <Box minW={["100%", "100%", "375px"]} {...xprops}>
      {showTitle && (
        <HStack
          justifyContent="space-between"
          w="100%"
          borderBottom={hasBorderBottom ? "1px solid #D4D2D2" : "none"}
          pb={hasBorderBottom ? "20px" : "initial"}
          mb={hasBorderBottom ? "40px" : "initial"}
        >
          <Text fontSize="lg" fontWeight="700">
            Recent Transactions
          </Text>
          {/* <Button
          size="sm"
          variant="unstyled"
          color="var(--primary)"
          px="10px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          onClick={() =>
            history.push(`/dashboard/wallet/${coin}/transactions`)
          }
        >
          View all
        </Button> */}
        </HStack>
      )}

      {isLoading && (
        <VStack py="20px">
          <CircularProgress isIndeterminate color="green.400" size="24px" />
        </VStack>
      )}

      {(transactions ?? items)?.length < 1 && !isLoading && (
        <VStack py="32px">
          <Box as={CgDatabase} fontSize="48px" color="grey" />
          <Text color="grey">No Data</Text>
        </VStack>
      )}

      {!isLoading && (
        <List maxW="100%" mt="10px">
          {(transactions ?? items)?.map((item, i) => (
            <TransactionItem
              key={`transaction-item-${i}`}
              {...item}
              isLast={i === (transactions ?? items).length - 1}
              _item={_tx ?? {}}
            />
          ))}
        </List>
      )}
    </Box>
  );
};

export default RecentTransaction;
